<template>
    <div class="CusstomEditor">
        <Editor :style="{ 'height': height }" v-model="html" :defaultConfig="editorConfig" :mode="mode"
            @onChange="onChange" @onCreated="onCreated" />
    </div>
</template>

<script>
import { Editor } from '@wangeditor/editor-for-vue'
export default {
    components: { Editor },
    props: {
        data: {
            type: String,
            default: ""
        },
        height: {
            type: String,
            default: "200px"
        }
    },
    data() {
        return {
            editor: null,
            html: '',
            editorConfig: { placeholder: '请输入内容...' },
            mode: 'default', // or 'simple'
        }
    },
    watch: {
        "data": function (val) {
            this.html = JSON.parse(JSON.stringify(val))
        }
    },
    created() {
        this.html = JSON.parse(JSON.stringify(this.data))
    },
    methods: {
        onCreated(editor) {
            this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
        },
        onChange() {
            this.$emit("handelChange", this.editor.getHtml())
        },
    },
    beforeDestroy() {
        const editor = this.editor
        if (editor == null) return
        editor.destroy() // 组件销毁时，及时销毁编辑器
    }
}
</script>
<style src="@wangeditor/editor/dist/css/style.css">

</style>
<style lang="scss" scoped>
.CusstomEditor {
    border: 1px solid #ccc;

    // /deep/ p {
    //     margin: 8px 0;
    // }

    // /deep/.w-e-text-placeholder {
    //     top: 0;
    // }
}
</style>